<template>
  <section class="p-1">
    <v-card class="mb-2 ma-2">
      <v-card-title>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-btn
          depressed
          @click="getRecalculateScore()"
          color="primary"
          class="ms-2"
          small
          ><v-icon small>mdi-calculator</v-icon>Re-Calculate
        </v-btn>
        <v-spacer></v-spacer>
        <v-chip color="error" small v-if="isRiskSetupDone">
          <span class="">{{
            isRiskSetupDone ? "Risk Setup Incomplete" : ""
          }}</span>
        </v-chip>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="RiskHeaders"
        :items="riskProfiling"
        :items-per-page="
          riskProfiling.length > 0 ? riskProfiling.length + 1 : 10
        "
        hide-default-footer
        :search="search"
        dense
        item-key="name"
      >
      </v-data-table>
    </v-card>
    <v-row class="my-2 mx-1">
      <v-col cols="12" md="6" lg="6" sm="12">
        <v-card class="ps-4" height="320px">
          <v-card-title class="ps-0 ms-0">
            <span>Periodic review on Customer Risk Profiling</span>
          </v-card-title>
          <v-row class="mx-1">
            <v-col cols="12">
              <label class="my-0 labelFontsize">Rivised Risk Profiling</label>
              <v-autocomplete
                class="rounded"
                dense
                outlined
                item-text="txt"
                item-value="val"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mx-1">
            <v-col cols="12">
              <label class="my-0 labelFontsize">Justification</label>
              <v-textarea class="rounded" dense outlined rows="3"></v-textarea>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mx-1">
            <v-col cols="12" class="mb-2">
              <v-btn small color="primary float-right">
                <v-icon small> mdi-content-save-edit-outline </v-icon> Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6" sm="12">
        <v-card class="ps-4" height="320px">
          <div id="chart">
            <apexchart
              type="rangeBar"
              height="320"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <b class="ms-4">Customer Risk Review History</b>
    <v-data-table fixed-header  height="55vh"
      class="pa-2"
      :headers="Headers"
      :items="RatesSummary"
      :search="search"
      dense
      item-key="name"
    >
    </v-data-table>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import Loading from "vue-loading-overlay";
export default {
  name: "Risk Profiling",
  props: {
    RiskData: {
      type: Array,
    },
  },
  data: () => {
    return {
      search: "",
      riskLevel: "",
      series: [
        // George Washington

        {
          name: "Low:0-30",
          data: [
            {
              x: "Risk Range",
              y: [0, 30],
            },
          ],
        },
        {
          name: "Medium:30-80",
          data: [
            {
              x: "Risk Range",
              y: [30, 80],
            },
          ],
        },
        {
          name: "High:80-100",
          data: [
            {
              x: "Risk Range",
              y: [80, 100],
            },
          ],
        },
        {
          name: "Customer",
          data: [
            {
              x: "Customer",
              y: [0, 15],
            },
          ],
        },
      ],
      isRiskSetupDone: null,
      chartOptions: {
        chart: {
          height: 250,
          type: "rangeBar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "20%",
            rangeBarGroupRows: true,
          },
        },
        colors: ["#008000", "#FFA500", "#FF0000", "#ff6b00"],
        fill: {
          type: "solid",
        },
        title: {
          text: "Profile Risk Score",
          align: "left",
        },
        xaxis: {
          type: "Percentage",
        },
        legend: {
          position: "right",
        },
      },
      loader: false,
      RiskHeaders: [
        { text: "Risk Profiling", value: "risk_type", sortable: false },
        { text: "Customer Details", value: "risk_sub_type", sortable: false },
        { text: "Weight", value: "weight", sortable: false },
        { text: "Score", value: "risk_score", sortable: false },
      ],
      Headers: [
        { text: "Update Status", value: "risk_filing", sortable: false },
        { text: "Remarks", value: "cus_details", sortable: false },
        { text: "Date", value: "weight", sortable: false },
        { text: "Review By", value: "score", sortable: false },
      ],
      riskProfiling: [],
      RatesSummary: [],
    };
  },
  components: {
    Loading,
  },
  computed: {},
  watch: {},
  mounted() {
    this.getRiskProfilingData();
    this.getRiskscore();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.riskProfiling) {
        this.exportToExcel(
          this.RiskHeaders,
          this.riskProfiling,
          "List of customers"
        );
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async getRecalculateScore() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getRecalculateScore(
          this.RiskData.pin_no
        );
        if (response.data.status_code === 200) {
          this.getRiskProfilingData();
          this.getRiskscore();
        } else {
          this.showAlertError(
            `Failed to Re-Calculate: ${response.data.message}`
          );
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getRiskscore() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getRiskscore("ITR");
        if (response.data.status_code === 200) {
          console.log("ITR codes", response.data.data);
          this.series = response.data.data.map((ele) => {
            return {
              name: `${ele.risk_status}: ${ele.min_risk_score}-${ele.max_risk_score}`,
              data: [
                {
                  x: "Risk Range",
                  y: [ele.min_risk_score, ele.max_risk_score],
                },
              ],
            };
          });
          this.series.push({
            name: "Customer",
            data: [
              {
                x: "Customer",
                y: [this.series[0].data[0].y[0], this.RiskData.percentage],
              },
            ],
          });
          this.transItems = response.data.data;
        }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    async getRiskProfilingData() {
      this.loader = true;
      try {
        const response = await commonService.getRiskProfilingData(
          null,
          this.RiskData.pin_no
        );
        if (response.status === 200) {
          this.riskProfiling = response.data.data[0].risk_data;
          this.riskLevel = response.data.data[0].risk_level;
          this.isRiskSetupDone = response.data.data[0].is_incomplete;
          this.riskProfiling.push({
            risk_type: "",
            risk_sub_type: `Risk Level: ${response.data.data[0].risk_level}`,
            weight: "Total",
            risk_score: `${this.RiskData.percentage} %`,
          });
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("countryOptions", this.riskProfiling);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.riskProfiling = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";

// tr:hover {
//   background: none !important;
// }
th {
  text-transform: uppercase;
}

.border {
  color: #ee0d0d;
}
.apexcharts-toolbar {
  display: none !important;
}
</style>
